import {
  U2000ApiValueToDisplayYmd,
  u2000FormatCivilWeekRangeLong,
  u2000ShiftCivilYmd,
} from "../../u2000Core/tools/U2000DateTimeHelpers";

/** Formate une date de période (lundi ISO YYYY-MM-DD ou instant) en plage « lundi … – dimanche … ». */
export function u3130FormatPeriodDateRange(periodDate: string): string {
  if (!periodDate?.trim()) return "";
  const mondayYmd = U2000ApiValueToDisplayYmd(periodDate);
  if (!mondayYmd) return periodDate;
  const sundayYmd = u2000ShiftCivilYmd(mondayYmd, 6);
  if (!sundayYmd) return mondayYmd;
  return u2000FormatCivilWeekRangeLong(mondayYmd, "fr-FR", true);
}
